import React from "react";
import { AiOutlineSend } from "react-icons/ai";
import { FaFacebook, FaInstagram } from "react-icons/fa";
import { SlSocialLinkedin, SlLocationPin } from "react-icons/sl";
import { BsYoutube } from "react-icons/bs";
import { LuPhone } from "react-icons/lu";
import { GrMailOption } from "react-icons/gr";

import footerBg from "../../Assets/Images/footer/Footer_bg.png";
import footerLogo from "../../Assets/Logos/logo_dark.png";
// import footerLogo from "../../Assets/Logos/afsa_logo.jpeg";
import { useNavigate } from "react-router-dom";
import { menuItems, contact_details } from "../../Assets/assests";

import { useApp } from "../../context/AppContext";

const UserFooter = () => {
  const date = new Date().getFullYear();
  const navigate = useNavigate();
  const { contact } = useApp();

  const handleNavigate = (path) => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    navigate(path);
  };

  const legalLinks = [
    { title: "Privacy Policy", path: "/privacy-policy" },
    { title: "Terms & Conditions", path: "/terms-conditions" },
    { title: "Child Safety Policy", path: "/child-safety-policy" },
  ];

  // STATIC FALLBACKS
  const fallback = {
    cooEmail: contact_details.cooEmail,
    phone: contact_details.mobile,
    headOfficeAddress: contact_details.address,
    socialLinks: {
      facebook: {
        url: "https://www.facebook.com/share/14RmcJzaYBY/i",
        isActive: true,
      },
      youtube: { url: "https://www.youtube.com/@aafsa_u2b", isActive: true },
      instagram: {
        url: "https://www.instagram.com/_aafsa_2022/?igsh=YjJiMDVpaTMzcm1s#",
        isActive: true,
      },
    },
  };

  // MERGED FINAL DATA
  const merged = {
    email: contact?.cooEmail || fallback.cooEmail,
    phone: contact?.phone || fallback.phone,
    headOfficeAddress: contact?.headOfficeAddress || fallback.headOfficeAddress,
    socialLinks: {
      facebook: contact?.socialLinks?.facebook || fallback.socialLinks.facebook,
      youtube: contact?.socialLinks?.youtube || fallback.socialLinks.youtube,
      instagram:
        contact?.socialLinks?.instagram || fallback.socialLinks.instagram,
      linkedin: contact?.socialLinks?.linkedin || { url: "", isActive: false },
    },
  };

  // SOCIAL ICON MAP
  const ICON_MAP = {
    facebook: <FaFacebook />,
    youtube: <BsYoutube />,
    instagram: <FaInstagram />,
    linkedin: <SlSocialLinkedin />,
  };

  // FINAL SOCIAL ICON LIST
  const dynamicSocialIcons = Object.entries(merged.socialLinks)
    .filter(([_, data]) => data?.isActive && data?.url)
    .map(([platform, data]) => ({
      platform,
      icon: ICON_MAP[platform] || null,
      url: data.url,
    }))
    .filter((item) => item.icon !== null);

  // CONTACT LIST DATA
  const contacts = [
    {
      icon: <GrMailOption className="text-lg sm:text-xl" />,
      text: merged.email,
    },
    {
      icon: <LuPhone className="text-lg sm:text-xl" />,
      text: merged.phone,
    },
    {
      icon: <SlLocationPin className="text-lg sm:text-xl mt-3" />,
      text: merged.headOfficeAddress,
      label: "Head Office",
    },
  ];

  return (
    <>
      <style>
        {`
          .fade-ellipse {
  -webkit-mask-image: radial-gradient(
    ellipse at center,
    rgba(0, 0, 0, 1) 30%,
    rgba(0, 0, 0, 0.6) 45%,
    rgba(0, 0, 0, 0.2) 60%,
    rgba(0, 0, 0, 0) 80%
  );
  mask-image: radial-gradient(
    ellipse at center,
    rgba(0, 0, 0, 1) 30%,
    rgba(0, 0, 0, 0.6) 45%,
    rgba(0, 0, 0, 0.2) 60%,
    rgba(0, 0, 0, 0) 80%
  );
}
}
        `}
      </style>
      <footer
        className="w-screen text-white pt-8 sm:pt-12 md:pt-20 lg:pt-28 pb-2 bg-[#111e1d] px-4 sm:px-6 md:px-12 lg:px-20"
        style={{
          backgroundImage: `url(${footerBg})`,
          backgroundBlendMode: "overlay",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
        }}
      >
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-10">
          {/* LOGO AND ABOUT SECTION */}
          <div className="lg:col-span-2">
            {/* DARK THEME */}
            <img
              src={footerLogo}
              alt="AAFSA Logo"
              className="h-12 md:h-20 mt-2 mb-4"
            />

            {/* LIGHT THEME  */}
            {/* <div className="relative w-fit">
              <img
                src={footerLogo}
                alt="AAFSA Logo"
                className="h-12 md:h-20 mt-2 mb-4 fade-ellipse"
              />
            </div> */}
            <p className="text-sm sm:text-base lg:text-base leading-relaxed mb-4 text-justify w-[90%]">
              AAFSA is a not for profit , non-political and social development
              organization established in 2022 dedicating to enhance the quality
              of lives of rural and urban poor in INDIA
            </p>

            {/* DYNAMIC SOCIAL ICONS */}
            <div className="mt-8">
              <ul className="flex flex-wrap gap-3 text-lg sm:text-xl lg:text-2xl">
                {dynamicSocialIcons.map((social, index) => (
                  <li key={index}>
                    <div
                      className="bg-transparent border-2 border-blue-200 rounded-lg p-2 sm:p-3 transition duration-300 animate-bounce hover:animate-none cursor-pointer"
                      style={{ animationDelay: `${index * 0.1}s` }}
                      onClick={() => window.open(social.url, "_blank")}
                    >
                      {social.icon}
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* QUICK LINKS */}
          <div>
            <h3 className="text-base sm:text-lg lg:text-xl mb-4 font-semibold text-white tracking-wide">
              QUICK LINKS
            </h3>
            <ul className="space-y-1 text-sm sm:text-base lg:text-lg cursor-pointer">
              {menuItems.map((link, index) => (
                <li
                  key={index}
                  className="hover:underline transition duration-300 text-sm sm:text-base text-gray-300 hover:text-white"
                  onClick={() => handleNavigate(link.path)}
                >
                  {link.title}
                </li>
              ))}
            </ul>

            <h3 className="text-base sm:text-lg lg:text-xl mt-6 mb-3 font-semibold text-white tracking-wide">
              OUR POLICIES
            </h3>
            <ul className="space-y-1 text-sm sm:text-base lg:text-lg cursor-pointer">
              {legalLinks.map((link, index) => (
                <li
                  key={index}
                  className="hover:underline transition duration-300 text-sm sm:text-base text-gray-300 hover:text-white"
                  onClick={() => handleNavigate(link.path)}
                >
                  {link.title}
                </li>
              ))}
            </ul>
          </div>

          {/* SUBSCRIBE */}
          <div>
            <h3 className="text-base sm:text-lg lg:text-xl mb-4">SUBSCRIBE</h3>
            <p className="text-sm sm:text-base lg:text-base mb-4 text-justify">
              Join our community and be the first to know about our initiatives,
              events, and opportunities to get involved.
            </p>
            <div className="relative h-10 sm:h-12">
              <input
                type="text"
                placeholder="Enter your email"
                className="w-full h-full px-3 sm:px-4 pr-10 text-xs sm:text-sm lg:text-base text-white bg-transparent border-2 border-gray-400 rounded-md placeholder:text-gray-400 outline-none"
              />
              <button className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-300 text-lg sm:text-xl">
                <AiOutlineSend />
              </button>
            </div>
          </div>

          {/* CONTACT INFO DYNAMIC */}
          <div>
            <h3 className="text-base sm:text-lg lg:text-xl mb-4">
              ALL CONTACTS
            </h3>
            <ul className="space-y-5 text-sm sm:text-base lg:text-base whitespace-pre-wrap">
              {contacts.map((contact, index) => (
                <li key={index} className="flex gap-3">
                  <span className="w-6 h-6 flex items-center justify-center ">
                    {contact.icon}
                  </span>
                  {contact.label && `${contact.label} - `}
                  {contact.label && <br />}
                  {contact.text}
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* COPYRIGHT AREA */}
        <div className="mt-10 border-t border-gray-700/60 pt-4">
          <div className="flex flex-col md:flex-row justify-between items-center text-xs sm:text-sm text-center gap-3 text-gray-400">
            <p>Aryalex Foundation. © {date} All Rights Reserved.</p>
            
            {/* Legal / Policy Links */}
            <div className="flex flex-wrap justify-center items-center gap-x-4 gap-y-1">
              {legalLinks.map((link, index) => (
                <React.Fragment key={index}>
                  <button
                    type="button"
                    onClick={() => handleNavigate(link.path)}
                    className="hover:text-white transition duration-200 cursor-pointer"
                  >
                    {link.title}
                  </button>
                  {index < legalLinks.length - 1 && (
                    <span className="text-gray-600 hidden sm:inline">•</span>
                  )}
                </React.Fragment>
              ))}
            </div>

            <div>
              Designed and developed by -{" "}
              <a
                className="hover:text-red-700"
                href="https://www.webbocket.com/"
                target="_blank"
                rel="noreferrer"
              >
                Web_Bocket
              </a>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default UserFooter;

// import React from "react";
// import { AiOutlineSend } from "react-icons/ai";
// import { FaGooglePlay, FaApple, FaFacebook, FaInstagram } from "react-icons/fa";
// import { FaXTwitter } from "react-icons/fa6";
// import { SlSocialLinkedin, SlLocationPin } from "react-icons/sl";
// import { BsYoutube } from "react-icons/bs";
// import { LuPhone } from "react-icons/lu";
// import { GrMailOption } from "react-icons/gr";
// import footerBg from "../../Assets/Images/footer/Footer_bg.png";
// import footerLogo from "../../Assets/Logos/logo_dark.png";
// import { useNavigate } from "react-router-dom";
// import { menuItems } from "../../Assets/assests";
// import { contact_details } from "../../Assets/assests";
// const UserFooter = () => {
//   const date = new Date().getFullYear();
//   const navigate = useNavigate();

//   const handleNavigate = (path) => {
//     window.scrollTo({ top: 0, behavior: "smooth" });
//     navigate(path);
//   };

//   const socialLinks = [
//     {
//       icon: <FaFacebook />,
//       links: "https://www.facebook.com/share/14RmcJzaYBY/i",
//       hoverColor: "#1877F2",
//     },
//     {
//       icon: <BsYoutube />,
//       hoverColor: "#FF0000",
//       // links: "https://www.youtube.com/@aafsakgi",
//       links: "https://www.youtube.com/@aafsa_u2b",
//     },
//     {
//       icon: <FaInstagram />,
//       hoverColor: "#E4405F",
//       links: "https://www.instagram.com/_aafsa_2022/?igsh=YjJiMDVpaTMzcm1s#",
//     },
//     // { icon: <SlSocialLinkedin />, hoverColor: "#0A66C2" },
//   ];

//   const contacts = [
//     {
//       icon: <GrMailOption className="text-lg sm:text-xl" />,
//       text: contact_details.email,
//     },
//     {
//       icon: <LuPhone className="text-lg sm:text-xl" />,
//       text: contact_details.mobile,
//     },
//     {
//       icon: <SlLocationPin className="text-lg sm:text-xl mt-3" />,
//       text: contact_details.address,
//       label: "Head Office",
//     },
//   ];

//   return (
//     <>
//       <footer
//         className="w-screen text-white pt-8 sm:pt-12 md:pt-20 lg:pt-28 pb-2 bg-[#111e1d]    px-4 sm:px-6 md:px-12 lg:px-20"
//         style={{
//           backgroundImage: `url(${footerBg})`,
//           backgroundBlendMode: "overlay",
//           backgroundSize: "cover",
//           backgroundRepeat: "no-repeat",
//           backgroundPosition: "center",
//         }}
//       >
//         <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-10">
//           {/* Logo + About */}
//           <div className="lg:col-span-2">
//             <img
//               src={footerLogo}
//               alt="AAFSA Logo"
//               // className="w-40 sm:w-48 md:w-56 lg:w-72 -mt-10 sm:-mt-20 md:-mt-12 lg:-mt-16 -ml-10 sm:-ml-16 md:-ml-12 -mb-4"
//               className="h-12 md:h-20 mt-2 mb-4"
//             />
//             <p className="text-sm sm:text-base lg:text-base font-base leading-relaxed mb-4 text-justify w-[90%]">
//               AAFSA is a not for profit , non-political and social development
//               organization established in 2022 dedicating to enhance the quality
//               of lives of rural and urban poor in INDIA
//             </p>

//             {/* Social Icons */}
//             <div className="mt-8">
//               <ul className="flex space-x-3 sm:space-x-4 text-lg sm:text-xl lg:text-2xl">
//                 {socialLinks.map((social, index) => (
//                   <li key={index}>
//                     <div
//                       className="bg-transparent border-2 border-blue-200 rounded-lg p-2 sm:p-3 transition duration-300 animate-bounce hover:animate-none cursor-pointer"
//                       style={{
//                         color: "inherit",
//                         animationDelay: `${index * 0.1}s`,
//                       }}
//                       onClick={() => {
//                         if (social.links) {
//                           window.open(social.links, "_blank");
//                         }
//                       }}
//                     >
//                       <div
//                         className="hover:[&_svg]:text-[inherit]"
//                         style={{ transition: "color 0.3s", color: "inherit" }}
//                       >
//                         {social.icon}
//                       </div>
//                     </div>
//                   </li>
//                 ))}
//               </ul>
//             </div>
//           </div>

//           {/* Quick Links */}
//           <div>
//             <h3 className="font-base text-base sm:text-lg lg:text-xl mb-4">
//               QUICK LINKS
//             </h3>
//             <ul className="space-y-1 text-sm sm:text-base lg:text-lg  cursor-pointer">
//               {menuItems.map((link, index) => (
//                 <li
//                   key={index}
//                   className="hover:underline transition duration-300 text-sm sm:text-base lg:text-base"
//                   onClick={() => handleNavigate(link.path)}
//                 >
//                   {link.title}
//                 </li>
//               ))}
//             </ul>
//           </div>

//           {/* Subscribe */}
//           <div>
//             <h3 className="font-base text-base sm:text-lg lg:text-xl mb-4">
//               SUBSCRIBE
//             </h3>
//             <p className="text-sm sm:text-base lg:text-base mb-4 font-base text-justify">
//               Join our community and be the first to know about our initiatives,
//               events, and opportunities to get involved. Your support helps us
//               make a difference!
//             </p>
//             <div className="relative h-10 sm:h-12">
//               <input
//                 type="text"
//                 placeholder="Enter your email"
//                 className="w-full h-full px-3 sm:px-4 pr-10 text-xs sm:text-sm lg:text-base text-white bg-transparent border-2 border-gray-400 rounded-md placeholder:text-gray-400 outline-none"
//               />
//               <button className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-300 text-lg sm:text-xl">
//                 <AiOutlineSend />
//               </button>
//             </div>
//           </div>

//           {/* Contact Info */}
//           <div>
//             <h3 className="font-base text-base sm:text-lg lg:text-xl mb-4">
//               ALL CONTACTS
//             </h3>
//             <ul className="space-y-5 text-sm sm:text-base lg:text-base font-base text-white">
//               {contacts.map((contact, index) => (
//                 <li key={index} className="flex gap-3">
//                   <span className="w-6 h-6 flex items-center justify-center">
//                     {contact.icon}
//                   </span>
//                   {contact?.label}
//                   {contact?.label && "- "}
//                   {contact?.label && <br />}
//                   {contact.text}
//                 </li>
//               ))}
//             </ul>
//           </div>
//         </div>

//         {/* Copyright */}
//         <div className="mt-10 ">
//           <div className="flex flex-col sm:flex-row justify-between items-center border-t py-4 text-xs sm:text-sm lg:text-base text-center gap-2 text-gray-400">
//             <p> Aryalex Foundation. © {date} All Rights Reserved.</p>
//             <div>
//               Designed and developed by -{" "}
//               <a
//                 className="hover:text-red-700"
//                 href="https://www.webbocket.com/"
//                 target="_blank"
//                 rel="noreferrer"
//               >
//                 Web_Bocket
//               </a>
//             </div>
//           </div>
//         </div>
//       </footer>
//     </>
//   );
// };

// export default UserFooter;
